import { Button } from "@mui/material";
import { useState } from "react";

interface Props {
  children: (isExpanded: boolean) => React.JSX.Element;
  showButtonLabel: string;
  hideButtonLabel: string;
  defaultExpanded?: boolean;
}

/**
 * ToggleContent provides a header with title and toggle button to show/hide child content.
 * Useful for collapsible sections where users need to expand/collapse content on demand.
 */
function ToggleContent({
  children,
  showButtonLabel,
  hideButtonLabel,
  defaultExpanded = false,
}: Props): React.JSX.Element {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const handleToggle = (): void => {
    setIsExpanded((old) => !old);
  };

  return (
    <>
      {children(isExpanded)}
      <Button variant="text" onClick={handleToggle}>
        {isExpanded ? hideButtonLabel : showButtonLabel}
      </Button>
    </>
  );
}

export { ToggleContent };
export type { Props as ToggleContentProps };
